import React, { Component } from 'react';
import Spinner from 'react-spinkit';
import { verifyPasswordResetCode, confirmPasswordReset } from 'firebase/auth';
import { authRef } from '../reference';
import validator from 'validator'

export default class ResetPassword extends Component {
  state = {
    email: null,
    error: '',
    password: '',
    success: false,
    validCode: null,
    verifiedCode: false,
  }

  componentDidMount() {
    // Verify the password reset code is valid.
    verifyPasswordResetCode(authRef, this.props.actionCode)
      .then(email => {
        this.setState({ email, validCode: true, verifiedCode: true });
      })
      .catch(error => {
        // Invalid or expired action code. Ask user to try to reset the password
        // again.
        this.setState({ error: error.message, validCode: false, verifiedCode: true });
      });
  }

  handleResetPassword = (event) => {
    event.preventDefault();
    const { actionCode } = this.props;
    const newPassword = this.state.password;

    // Save the new password.
    if (validator.isStrongPassword(newPassword, {
      minLength: 8, minLowercase: 1,
      minUppercase: 1, minNumbers: 1, minSymbols: 0,
    })) {
      confirmPasswordReset(authRef, actionCode, newPassword)
        .then(() => {
          // Password reset has been confirmed and new password updated.
          this.setState({ success: true });
        })
        .catch(error => {
          // Error occurred during confirmation. The code might have expired or the
          // password is too weak.
          this.setState({ error: error.message });
        });
    } else {
      this.setState({ error: 'Password must have at least 8 characters, with one number, one uppercase, and one lowercase.' });
    }
  }

  setText = (evt) => {
    this.setState({ password: evt.target.value });
  }

  render() {
    const {
      email,
      error,
      password,
      success,
      validCode,
      verifiedCode,
    } = this.state;

    let component;
    if (!verifiedCode) {
      component = <Spinner spinnerName="three-bounce" />;
    } else if (success) {
      component = (
        <div className="ResetPassword">
          <h1>Password changed</h1>
          <p>You can now sign in with your new password</p>
        </div>
      );
    } else if (verifiedCode && validCode) {
      component = (
        <div className="ResetPassword">
          <h1>Reset your password</h1>
          <div style={{ paddingBottom: '14px' }}>for <span>{email}</span></div>

          <form onSubmit={this.handleResetPassword}>

            {error ? <div className="error">{error}</div> : ''}

            <input
              onChange={this.setText}
              value={password}
              type="password"
              placeholder="New password"
              style={{ marginBottom: '14px' }}
              required
            />
            <input
              type="submit"
              value="SAVE"
            />
          </form>
        </div>
      );
    } else if (verifiedCode && !validCode) {
      component = (
        <div className="ResetPassword">
          <h1>Try resetting your password again</h1>
          <p className="error">{error}</p>
        </div>
      );
    }

    return component;
  }
}
